import { useCallback, useEffect, useMemo } from 'react'
import { connect, useDispatch } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { Redirect } from 'react-router-dom'
// import BreadCrumbs from '../components/general/BreadCrumbs.js'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import AgenciesControl from '../components/agencies/AgenciesDropdown.js'
import { currentAdminPropTypes } from '../reducers/adminsReducer'
import { currentAgencyPropTypes } from '../reducers/currentReducer.js'
import { handleLogout } from '../redux/actions/auth/index.js'
import { routePropTypes } from '../routes'

const modalStyle = {
  maxWidth: '500px',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // overflow: 'auto',
  display: 'block',
  maxHeight: '100%',
  marginRight: 'auto',
  marginLeft: 'auto'
}
/**
 *
 * @param {Object} props
 * @param {import('../routes.js').Route} props.route
 * @param {import('../reducers/adminsReducer.js').CurrentAdmin} props.currentAdmin
 * @param {import('../reducers/currentReducer.js').CurrentAgency} props.currentAgency
 *
 * @returns {JSX.Element}
 */
function ProtectedRouteComponent({ route, currentAdmin, currentAgency, ...props }) {
  const { component: Component, path, orgLevel } = route

  const dispatch = useDispatch()

  const handleAdminLevel = useCallback(() => {
    if (currentAdmin.logged_in_as === 'Agency')
      console.info(`Attempting to access Organization route as Agency. Redirecting...`)
    if (currentAdmin.logged_in_as === 'Organization')
      console.info(`Attempting to access Agency route as Organization. Redirecting...`)
  }, [currentAdmin.logged_in_as])

  const clientAdminAllowedPaths = useMemo(
    () => ['/', '/dashboard', '/orders/review', '/order_approval', '/update_password'],
    []
  )

  useEffect(() => {
    handleAdminLevel()
  }, [handleAdminLevel])

  if (
    (orgLevel && currentAdmin.logged_in_as === 'Agency') ||
    (!orgLevel && currentAdmin.logged_in_as === 'Organization' && path !== '/dashboard') // Prevent loop
  )
    return <Redirect to="/dashboard" />

  if (currentAdmin.is_client_admin && !clientAdminAllowedPaths.includes(path)) {
    toastr.error('Attention', "You don't have permission to access this page")

    return <Redirect to="/orders/review" />
  }

  return (
    <>
      {/* <BreadCrumbs route={route} /> */}
      <Component {...props} />
      <Modal
        isOpen={currentAgency?.maintenance_mode && currentAdmin.organization_admins.length === 0}
        style={modalStyle}
      >
        <ModalHeader>{currentAgency?.name} is in maintenance mode</ModalHeader>
        <ModalBody>
          <AgenciesControl>
            <div className="d-flex justify-content-between align-items-center">
              <AgenciesControl.Dropdown style={{ width: '60%' }} />
              <AgenciesControl.LogoutButton />
            </div>
          </AgenciesControl>
        </ModalBody>
        <ModalFooter>
          <Button
            color="link"
            onClick={async () => {
              await dispatch(handleLogout(currentAdmin))
            }}
          >
            Sign out
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

ProtectedRouteComponent.propTypes = {
  route: routePropTypes,
  currentAdmin: currentAdminPropTypes,
  currentAgency: currentAgencyPropTypes
}

export default connect(state => ({
  currentAdmin: state.admins.current_admin,
  currentAgency: state.current.agency
}))(ProtectedRouteComponent)
